const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`7fccab61692b63bf225f388379b5dda86c6840235750223b16345b35137df6fe`, `7fccab61692b63bf225f388379b5dda86c6840235750223b16345b35137df6fe`, 1, 84), undefined, true, false, 1));
            }

            getTemplateName() {
                return `7fccab61692b63bf225f388379b5dda86c6840235750223b16345b35137df6fe`;
            }

            getSourceContext() {
                return new this.Source(``, `7fccab61692b63bf225f388379b5dda86c6840235750223b16345b35137df6fe`, ``);
            }
        }],
        [84, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/event-log/event-log.twig`, `7fccab61692b63bf225f388379b5dda86c6840235750223b16345b35137df6fe`, 1);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/event-log/event-log.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable((context.has(`items`) ? context.get(`items`) : null));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                context.set('loop', new Map([
                  ['parent', context.get('_parent')],
                  ['index0', 0],
                  ['index', 1],
                  ['first', true]
                ]));
                if ((typeof context.get('_seq') === 'object') && this.isCountable(context.get('_seq'))) {
                    let length = this.count(context.get('_seq'));
                    let loop = context.get('loop');
                    loop.set('revindex0', length - 1);
                    loop.set('revindex', length);
                    loop.set('length', length);
                    loop.set('last', (length === 1));
                }
                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`item`] = __value__;
                    this.echo(`      `);
                    this.echo(this.include(context, this.source, this.loadTemplate(`7fccab61692b63bf225f388379b5dda86c6840235750223b16345b35137df6fe`, `7fccab61692b63bf225f388379b5dda86c6840235750223b16345b35137df6fe`, 4, 83), context.get(`item`), true, false, 4));
                    this.echo(`    `);
                    (() => {
                        let loop = context.get('loop');
                        loop.set('index0', loop.get('index0') + 1);
                        loop.set('index', loop.get('index') + 1);
                        loop.set('first', false);
                        if (loop.has('length')) {
                            loop.set('revindex0', loop.get('revindex0') - 1);
                            loop.set('revindex', loop.get('revindex') - 1);
                            loop.set('last', loop.get('revindex0') === 0);
                        }
                    })();
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('item');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`  `);
            }

            getTemplateName() {
                return `7fccab61692b63bf225f388379b5dda86c6840235750223b16345b35137df6fe`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `7fccab61692b63bf225f388379b5dda86c6840235750223b16345b35137df6fe`, ``);
            }
        }],
        [83, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/event-log/item.twig`, `7fccab61692b63bf225f388379b5dda86c6840235750223b16345b35137df6fe`, 4);

                this.blocks = new Map([
                    ['extra', [this, 'block_extra']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/event-log/item.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_extra(context, blocks = new Map()) {
                let macros = this.macros.clone();
                if (this.traceableMethod(this.getAttribute, 6, this.source)(this.env, (context.has(`item`) ? context.get(`item`) : null), `links`, new Map([]), `any`, false, false, false)) {
                    this.echo(this.include(context, this.source, this.loadTemplate(`7fccab61692b63bf225f388379b5dda86c6840235750223b16345b35137df6fe`, `7fccab61692b63bf225f388379b5dda86c6840235750223b16345b35137df6fe`, 7, 82), new Map([[`class`, `o-list--inline`]]), true, false, 7));
                }
            }

            getTemplateName() {
                return `7fccab61692b63bf225f388379b5dda86c6840235750223b16345b35137df6fe`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `7fccab61692b63bf225f388379b5dda86c6840235750223b16345b35137df6fe`, ``);
            }
        }],
        [82, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/list/list.twig`, `7fccab61692b63bf225f388379b5dda86c6840235750223b16345b35137df6fe`, 7);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/list/list.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable(this.traceableMethod(this.getAttribute, 11, this.source)(this.env, (context.has(`item`) ? context.get(`item`) : null), `links`, new Map([]), `any`, false, false, false));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`link`] = __value__;
                    this.echo(`                  <li>
                    <a href="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(13, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 13, this.source)(this.env, context.get(`link`), `link`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`">
                      `);
                    this.echo(this.env.getFilter('escape').traceableCallable(14, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 14, this.source)(this.env, context.get(`link`), `title`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`
                    </a>
                  </li>
                `);
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('link');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`              `);
            }

            getTemplateName() {
                return `7fccab61692b63bf225f388379b5dda86c6840235750223b16345b35137df6fe`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `7fccab61692b63bf225f388379b5dda86c6840235750223b16345b35137df6fe`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '7fccab61692b63bf225f388379b5dda86c6840235750223b16345b35137df6fe');

let template = env.loadTemplate('7fccab61692b63bf225f388379b5dda86c6840235750223b16345b35137df6fe');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/event-log/demo/events.twig", args: context }
     );
     return rendered;;
};